module.exports = __webpack_public_path__ + "img/E-WEB-Goal-14.16693abe.svg";